import { Component, inject } from '@angular/core';
import { QUINNY_AI_AVATAR_URL } from '@core';
import { NzModalRef } from 'ng-zorro-antd/modal';

// Toggle between image-based poster mode and detailed interactive mode
// Set to true to use the simplified image poster, false for the detailed modal
const USE_IMAGE_MODE = true;

@Component({
  selector: 'app-quinny-campaign',
  templateUrl: './quinny-campaign.component.html',
  styleUrls: ['./quinny-campaign.component.less'],
  standalone: false
})
export class QuinnyCampaignComponent {
  private modalRef = inject(NzModalRef);
  readonly quinnYAiAvatarUrl = QUINNY_AI_AVATAR_URL;

  readonly useImageMode = USE_IMAGE_MODE;
  readonly campaignPosterUrl =
    'https://cdn.qne.cloud/qca/assets/img/quinny-ai/Campaign-Poster-Final.png';

  onTryNow(): void {
    this.modalRef.close({ action: 'try-now' });
  }

  onClose(): void {
    this.modalRef.close({ action: 'dismiss' });
  }
}
